import { Component, computed, input, output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonComponent } from '@examdojo/core/button';
import { IconComponent } from '@examdojo/core/icon';

@Component({
  selector: 'dojo-selector-badge',
  template: `
    @if (disabled()) {
      <div
        class="font inline-flex h-7 w-[60px] items-center justify-center rounded-lg border border-neutral-200 px-2 py-1 text-sm font-semibold"
        style="opacity: 0.8"
        [class]="badgeClasses()"
        [style.background-color]="fill() === 'solid' ? color() : 'transparent'"
        [style.color]="fill() === 'solid' ? 'white' : color()"
        [matTooltip]="longLabel()"
      >
        <span>{{ label() }}</span>
      </div>
    } @else {
      <dojo-button
        [size]="'xs'"
        [customWidth]="78"
        [customColor]="color()"
        [fill]="fill()"
        [matTooltip]="longLabel()"
        (click)="clicked.emit()"
      >
        <div class="flex w-full items-center justify-between">
          <span>{{ label() }}</span>
          <dojo-icon [icon]="'chevron-right'" class="ml-1.5" />
        </div>
      </dojo-button>
    }
  `,
  imports: [IconComponent, ButtonComponent, MatTooltipModule],
})
export class SelectorBadgeComponent {
  readonly active = input(false);
  readonly color = input.required<string>();
  readonly label = input.required<string>();
  readonly longLabel = input<string | undefined>(undefined);
  readonly disabled = input.required<boolean>();
  readonly fill = computed(() => (this.active() ? 'solid' : 'outline'));
  readonly clicked = output<void>();

  readonly badgeClasses = computed(() => {
    return this.fill() === 'solid' ? 'border-transparent' : '';
  });
}
